import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { useNavigate } from 'react-router-dom';
import { iconoPorOrigen } from '../utils/notificacionUtils';
import useNotificacionesSistema from '../hooks/useNotificacionesSistema';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const NotificacionCampana = () => {
    const [popoverVisible, setPopoverVisible] = useState(false);
    const popoverRef = useRef(null);
    const navigate = useNavigate();

    const {
        notificaciones, loading, nuevasCount, hayNoLeidas,
        selectedEvent, closeEventModal,
        abrirNotificacion: abrirNotificacionHook,
        descartar,
    } = useNotificacionesSistema();

    const estaLeida = (notificacion) => notificacion?.leido === true;

    const abrirNotificacion = (notif) => {
        abrirNotificacionHook(notif, { onNavegar: () => setPopoverVisible(false) });
    };

    const handleDescartar = (e, idNotificacion) => {
        e.stopPropagation();
        descartar(idNotificacion);
    };

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (popoverRef.current && !popoverRef.current.contains(e.target)) {
                setPopoverVisible(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className="position-relative d-flex align-items-center justify-content-center" ref={popoverRef} style={{ width: '100%', height: '100%' }}>
            <button
                className="btn position-relative p-0 border-0 d-flex align-items-center justify-content-center"
                onClick={() => setPopoverVisible(!popoverVisible)}
                style={{
                    width: '100%',
                    height: '100%'
                }}
            >
                <i
                    className={`bi bi-bell-fill ${
                        hayNoLeidas ? 'text-warning shake-bell' : 'text-light'
                    }`}
                    style={{
                        fontSize: '39px',
                        transition: 'transform 0.25s ease, color 0.25s ease',
                    }}
                    onMouseEnter={e => (e.currentTarget.style.transform = 'scale(1.15)')}
                    onMouseLeave={e => (e.currentTarget.style.transform = 'scale(1)')}
                ></i>
                {hayNoLeidas && (
                    <span
                        className="position-absolute rounded-circle"
                        style={{ width: '14px', height: '14px', top: '16%', right: '12%', backgroundColor: '#ffc107' }}
                    />
                )}
                {nuevasCount > 0 && (
                    <span
                        className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-warning text-dark"
                        style={{ fontSize: '0.9rem', minWidth: '28px', padding: '0.35rem 0.5rem' }}
                    >
                        {nuevasCount}
                    </span>
                )}
            </button>

            {/* LISTA DE NOTIFICACIONES */}
            {popoverVisible && (
                <div
                    className="position-absolute end-0"
                    style={{
                        top: '100%',
                        marginTop: '10px',
                        width: '420px',
                        maxWidth: '94vw',
                        background: '#fff',
                        border: '1px solid #e2e8f0',
                        borderRadius: '12px',
                        boxShadow: 'var(--shadow-lg)',
                        zIndex: 3000,
                        overflow: 'hidden',
                    }}
                >
                    {/* Encabezado */}
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '14px 16px 12px',
                        borderBottom: '1px solid #e2e8f0',
                        background: '#1e40af',
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <i className="bi bi-bell-fill" style={{ color: '#fbbf24', fontSize: '1rem' }} />
                            <span style={{ fontWeight: 700, color: '#fff', fontSize: '0.95rem' }}>Notificaciones</span>
                            {nuevasCount > 0 && (
                                <span style={{
                                    background: '#fbbf24', color: '#1e293b', borderRadius: '20px',
                                    padding: '1px 9px', fontSize: '0.72rem', fontWeight: 700,
                                }}>
                                    {nuevasCount} nueva{nuevasCount !== 1 ? 's' : ''}
                                </span>
                            )}
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            <button
                                type="button"
                                onClick={() => { setPopoverVisible(false); navigate('/notificaciones'); }}
                                title="Ver todas las notificaciones"
                                style={{
                                    background: 'rgba(255,255,255,0.12)', border: 'none', borderRadius: 6,
                                    color: '#fff', cursor: 'pointer', padding: '3px 9px', fontSize: '0.78rem',
                                    fontWeight: 600, lineHeight: 1.6,
                                }}
                            >
                                Ver todas
                            </button>
                            <button
                                type="button"
                                onClick={() => setPopoverVisible(false)}
                                style={{
                                    background: 'rgba(255,255,255,0.12)', border: 'none', borderRadius: 6,
                                    color: '#fff', cursor: 'pointer', padding: '3px 8px', fontSize: '0.95rem',
                                    lineHeight: 1,
                                }}
                            >
                                <i className="bi bi-x-lg" />
                            </button>
                        </div>
                    </div>

                    {/* Cuerpo */}
                    <div style={{ maxHeight: '440px', overflowY: 'auto' }}>
                        {loading ? (
                            <div style={{ textAlign: 'center', padding: '28px 16px', color: '#94a3b8' }}>
                                <div className="spinner-border spinner-border-sm text-primary mb-2" />
                                <div style={{ fontSize: '0.85rem' }}>Cargando…</div>
                            </div>
                        ) : notificaciones.length === 0 ? (
                            <div style={{ textAlign: 'center', padding: '36px 16px', color: '#94a3b8' }}>
                                <i className="bi bi-bell-slash" style={{ fontSize: '2rem', display: 'block', marginBottom: 8 }} />
                                <div style={{ fontSize: '0.88rem' }}>Sin notificaciones pendientes</div>
                            </div>
                        ) : (
                            notificaciones.map(item => {
                                const leida = estaLeida(item);
                                const { icon, color } = iconoPorOrigen(item);
                                const fecha = item.fechaProgramada ? new Date(item.fechaProgramada) : null;
                                const accentColor = leida ? '#94a3b8' : color;
                                return (
                                    <div
                                        key={item.id}
                                        onClick={() => abrirNotificacion(item)}
                                        style={{
                                            display: 'flex',
                                            gap: 12,
                                            padding: '12px 16px',
                                            borderBottom: '1px solid #f1f5f9',
                                            cursor: 'pointer',
                                            background: leida ? '#fff' : '#fffbeb',
                                            transition: 'background 0.12s',
                                            position: 'relative',
                                        }}
                                        onMouseEnter={e => { e.currentTarget.style.background = leida ? '#f8fafc' : '#fef9c3'; }}
                                        onMouseLeave={e => { e.currentTarget.style.background = leida ? '#fff' : '#fffbeb'; }}
                                    >
                                        {/* Franja de color izquierda */}
                                        <div style={{
                                            width: 3, borderRadius: 4, background: leida ? '#e2e8f0' : accentColor,
                                            flexShrink: 0, alignSelf: 'stretch',
                                        }} />

                                        {/* Ícono */}
                                        <div style={{
                                            width: 32, height: 32, borderRadius: '50%',
                                            background: leida ? '#f1f5f9' : `${accentColor}18`,
                                            display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                                        }}>
                                            <i className={`bi ${icon}`} style={{ color: leida ? '#94a3b8' : accentColor, fontSize: '0.9rem' }} />
                                        </div>

                                        {/* Contenido */}
                                        <div style={{ flex: 1, minWidth: 0 }}>
                                            <div style={{
                                                fontSize: '0.86rem', fontWeight: leida ? 400 : 600,
                                                color: leida ? '#64748b' : '#1e293b', lineHeight: 1.4,
                                                marginBottom: 5,
                                                overflow: 'hidden', display: '-webkit-box',
                                                WebkitLineClamp: 3, WebkitBoxOrient: 'vertical',
                                            }}>
                                                {item.mensaje}
                                            </div>
                                            {fecha && (
                                                <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                                                    <span style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: '0.74rem', color: '#94a3b8', fontVariantNumeric: 'tabular-nums' }}>
                                                        <i className="bi bi-calendar3" style={{ fontSize: '0.7rem' }} />
                                                        {fecha.toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric' })}
                                                    </span>
                                                    <span style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: '0.74rem', color: '#94a3b8', fontVariantNumeric: 'tabular-nums' }}>
                                                        <i className="bi bi-clock" style={{ fontSize: '0.7rem' }} />
                                                        {fecha.toLocaleTimeString('es-AR', { hour: '2-digit', minute: '2-digit' })}
                                                    </span>
                                                </div>
                                            )}
                                        </div>

                                        {/* Botón descartar */}
                                        <button
                                            type="button"
                                            aria-label="Descartar"
                                            onClick={(e) => handleDescartar(e, item.id)}
                                            style={{
                                                background: 'none', border: 'none', cursor: 'pointer',
                                                color: '#94a3b8', padding: '2px 4px', borderRadius: 4,
                                                fontSize: '0.8rem', alignSelf: 'flex-start', flexShrink: 0,
                                                lineHeight: 1,
                                            }}
                                            onMouseEnter={e => { e.currentTarget.style.color = '#475569'; e.currentTarget.style.background = '#f1f5f9'; }}
                                            onMouseLeave={e => { e.currentTarget.style.color = '#94a3b8'; e.currentTarget.style.background = 'none'; }}
                                        >
                                            <i className="bi bi-x-lg" />
                                        </button>
                                    </div>
                                );
                            })
                        )}
                    </div>
                </div>
            )}

            {/* 🪶 MODAL DE EVENTO (Renderizado en Portal para evitar conflictos de z-index y overflow) */}
            {selectedEvent && ReactDOM.createPortal(
                <div className="event-dropdown-overlay" onClick={closeEventModal} style={{ zIndex: 9999 }}>
                    <div className="event-dropdown" onClick={e => e.stopPropagation()}>
                        <div className="dropdown-header">
                            <h4>Detalles del Evento</h4>
                            <button className="dropdown-close-btn" onClick={closeEventModal}>×</button>
                        </div>

                        <div className="event-details">
                            <div className="event-title">
                                <h3>{selectedEvent.titulo}</h3>
                            </div>

                            <div className="event-info">
                                <div className="info-item">
                                    <span className="info-label">📅 Fecha:</span>
                                    <span className="info-value">
                            {new Date(selectedEvent.fecha).toLocaleDateString()}
                        </span>
                                </div>

                                <div className="info-item">
                                    <span className="info-label">🕐 Horario:</span>
                                    <span className="info-value">
                            {selectedEvent.todoElDia
                                ? "Todo el día"
                                : `${selectedEvent.horaInicio || "–"} a ${selectedEvent.horaFin || "–"}`}
                        </span>
                                </div>

                                <div className="info-item">
                                    <span className="info-label">🏷️ Tipo:</span>
                                    <span className="info-value">
                            {typeof selectedEvent.tipoEvento === "string"
                                ? selectedEvent.tipoEvento
                                : selectedEvent.tipoEvento?.nombre || "Sin tipo"}
                        </span>
                                </div>

                                {selectedEvent.idTramite && (
                                    <div className="info-item">
                                        <span className="info-label">📋 Trámite asociado:</span>
                                        <span className="info-value">ID #{selectedEvent.idTramite}</span>
                                    </div>
                                )}
                            </div>

                            {selectedEvent.descripcion && (
                                <div className="event-description mt-2">
                                    <div className="descripcion-label">📝 Descripción:</div>
                                    <div className="descripcion-text">{selectedEvent.descripcion}</div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>,
                document.body
            )}
        </div>
    );
};

export default NotificacionCampana;
